import React from "react";
import type { Project } from "../../../api/useProjects";
import { ImportSnapshotAction } from "./ImportSnapshotAction";
import MagicActions from "./MagicActions";
import { useSettings } from "../../../api/useSettings";
import { CopyingProjectAnalysesAction } from "./CopyingProjectAnalysesAction/CopyingProjectAnalysesAction";
import { LaunchAnalysisSelectionAction } from "./LaunchAnalysisSelectionAction/LaunchAnalysisSelectionAction";

interface P {
  project: Project;
}

const ProjectActions = ({ project }: P) => {
  const settings = useSettings();
  return (
    <>
      {settings.SOURCE_SNAPSHOT_IMPORT_IN_PROJECT && <ImportSnapshotAction project={project} />}
      <LaunchAnalysisSelectionAction project={project} />
      <CopyingProjectAnalysesAction project={project} />
      <MagicActions project={project} />
    </>
  );
};
export default ProjectActions;
